import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Agency {
  id: string;
  name: string;
}

type Theme = "light" | "dark" | "system";

interface AppState {
  currentAgency: Agency | null;
  setCurrentAgency: (agency: Agency | null) => void;

  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;

  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      currentAgency: null,
      setCurrentAgency: (agency) => set({ currentAgency: agency }),

      sidebarCollapsed: false,
      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) =>
        set({ sidebarCollapsed: collapsed }),

      theme: "light",
      setTheme: (theme) => {
        const root = document.documentElement;
        root.classList.remove("light", "dark");

        if (theme === "system") {
          const prefersDark = window.matchMedia(
            "(prefers-color-scheme: dark)",
          ).matches;
          root.classList.add(prefersDark ? "dark" : "light");
        } else {
          root.classList.add(theme);
        }

        set({ theme });
      },
    }),
    {
      name: "alice-app-state",
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        theme: state.theme,
        currentAgency: state.currentAgency,
      }),
    },
  ),
);
